const KEYNAME = {
  TAG_API_REF: 'tag',
  TAG_NAME_API_REF: 'tag_name',
  TAG_CONTAINER: 'tagContainer',
  TAG_NAME_INPUT: 'tagNameInput',
};

export default KEYNAME;
